import {styled, useTheme} from "@mui/material/styles";
import {NavLink} from "react-router-dom";

import logo from '../assets/logo-small.svg';
import logoWhite from '../assets/logo-white.png';

const StyledLogo = styled(NavLink)({
  display: 'flex',
  maxHeight: '100%',
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '100%',
  '> img': {
    maxWidth: '100%',
  },
});

const Logo = () => {
  const theme = useTheme();
  return (
    <StyledLogo to="/">
      <img src={theme.palette.mode === 'dark' ? logoWhite : logo} alt="OneKey Logo" />
    </StyledLogo>
  );
};

export default Logo;
